import Language from './language';

export default class ProcessingActivity_Translation {
  processingActivityId: number;

  languageId: number;

  name: string;

  description: string;

  purpose: string;

  lang?: Language;

  constructor() {
    this.processingActivityId = -1;
    this.languageId = -1;
    this.name = '';
    this.description = '';
    this.purpose = '';
  }

    clone(): ProcessingActivity_Translation {
        const output = new ProcessingActivity_Translation();
        output.processingActivityId = this.processingActivityId;
        output.languageId = this.languageId;
        output.name = this.name;
        output.description = this.description;
        
        output.lang = this.lang ? this.lang.clone() : this.lang;
    
        return output;
    }
}
